// features/workstations/property-dossier/analyzing-state.js
// Loading state while the dossier is computed + synthesized.

export default function AnalyzingState({ address }) {
  return (
    <div style={{
      display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
      padding: '64px 24px', textAlign: 'center', gap: 14,
    }}>
      <div style={{
        width: 40, height: 40, borderRadius: '50%',
        border: '3px solid var(--border-2)', borderTopColor: '#c8a96e',
        animation: 'spin 0.9s linear infinite',
      }} />
      <div style={{ fontSize: 15, fontWeight: 600 }}>Analyzing deal…</div>
      <div style={{ fontSize: 13, color: '#888', maxWidth: 360 }}>
        {address ? <><span style={{ color: '#c8a96e' }}>{address}</span> — </> : null}
        pulling comps + demographics, running the deal math and tax engine, then synthesizing your dossier.
      </div>
      <style jsx>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
    </div>
  );
}
